import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * MainGridRowDetailPachi
 */
class MainGridRowDetailPachi extends React.Component {

  constructor(props) {
    super(props);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.createGridValue = this.createGridValue.bind(this);
  }

  handleLinkClick(event, kisyuCd) {
    event.preventDefault();
    event.stopPropagation();
    commonLogic.handleUsedMachinePriceClick(event, kisyuCd);
  }

  /**
   * グリッド値作成
   * @param {*} targetHeaderItem
   * @returns
   */
  createGridValue(targetHeaderItem) {
    let targetValue = this.props.gridData[targetHeaderItem.koumokuKey];
    let decimalPoint = targetHeaderItem.decimalPoint;

    let node = null;
    // 中古価格の場合
    if (targetHeaderItem.key == 'used_machine_price') {
      let s = '-';
      let style = null;
      if (targetValue !== '' && targetValue !== 0) {
        s = commonLogic.numberFormat(targetValue, decimalPoint);
        if (parseFloat(style) < 0) {
          style = 'minus_value';
        }
      }
      // 中古価格の機種コード(p-sensor機種コード)
      let kisyuCd = '';
      const psensorInfo = this.props.gridData['p_sensor'];
      if (psensorInfo !== undefined) {
        kisyuCd = psensorInfo.kisyu_cd;
      }

      if (s != '-') {
        node = (
          <a className={`used_machine_price ${style}`} href="#" onClick={(event) => { this.handleLinkClick(event, kisyuCd); }}>&yen;{s}</a>
        );
      } else {
        node = (
          <a className="used_machine_price" href="#" onClick={(event) => { this.handleLinkClick(event, kisyuCd); }}>{s}</a>
        );
      }

      return node;
    }

    // 中古価格増減
    if (targetHeaderItem.key == 'zogen_used_machine_price') {
      // 中古価格増減
      let s = '-';
      if (targetValue !== '') {
        if (targetValue != undefined && targetValue != 0) {
          s = commonLogic.numberFormat(targetValue, decimalPoint);
          if (0 < parseInt(s.replace(/,/g, ''), 10)) {
            s = '+' + s;
          }
        } else {
          s = String(0);
        }
      }

      if (s === '-') return (<span>{s}</span>);
      if (s.startsWith('+')) return (<span>+&yen;{s.slice(1)}</span>);
      if (s.startsWith('-')) return (<span className="minus_value">-&yen;{s.slice(1)}</span>);

      return (<span className="noto-sans-text">&plusmn;&yen;{s}</span>);
    }


    if (decimalPoint != null) {
      let s = commonLogic.numberFormat(targetValue, decimalPoint);
      if (s.match('-') && s != '-') {
        node = (<span className="minus_value">{s}</span>);
      } else {
        node = (<span>{s}</span>);
      }
    } else {
      node = (<span>{targetValue}</span>);
    }


    return node;
  }


  render() {
    const headerInfo = this.props.gridHeaderInfo;
    const gridRowPosList = Array.from(new Set(headerInfo.map(item => item.rowPos)));

    const Nodes = [];
    // メーカー・タイプの場合は横幅を超えたら末尾を「・・・」にする
    const create = (item) => {
      if (item.key === 'brand_display_name' || item.key === 'type_display_name') {
        return (
          <div className="grid_item_detail">
            <div className="col_koumoku_header" key={item.id}>
              <p className="nh">{item.name1}</p>
            </div>
            <div className="col_koumoku_body col_komoku_body_settei_mt" >
              {this.createGridValue(item)}
            </div>
          </div>
        );
      } else {
        return (
          <div className="grid_item_detail">
            <div className="col_koumoku_header" key={item.id}>
              <p className="nh">{item.name1}</p>
            </div>
            <div className="col_koumoku_body" >
              {this.createGridValue(item)}
            </div>
          </div>
        );
      }
    };

    // 2行になる項目が存在する行のヘッダーの高さを調整
    const create2 = (item) => {
      let headerName = null;
      if (item.name2 != null && item.name2 != undefined) {
        headerName = (
          <p className="nh">{item.name1}<br />{item.name2}</p>
        );
      } else {
        headerName = (
          <p className="nh">{item.name1}</p>
        );
      }
      return (
        <div className="grid_item_detail">
          <div className="col_koumoku_header height_adujust fb x_center" key={item.id}>
            {headerName}
          </div>
          <div className="col_koumoku_body" >
            {this.createGridValue(item)}
          </div>
        </div>
      );
    };


    for (let i = 0; i < gridRowPosList.length; i++) {
      const targetHeaderList = headerInfo.filter(item => item.rowPos == i);
      const row = targetHeaderList.map((headerItem) => {
        if (i == 1 || i == 2) {
          return create2(headerItem);
        } else {
          return create(headerItem);
        }

      });
      if (i == gridRowPosList.length - 1) {
        Nodes.push(
          <div className="fb flex_1">
            {row}
            <div className="grid_item_detail">
              <div className="col_koumoku_header" >
                <p className="nh">&nbsp;</p>
              </div>
              <div className="col_koumoku_body" />
            </div>
            <div className="grid_item_detail">
              <div className="col_koumoku_header">
                <p className="nh">&nbsp;</p>
              </div>
              <div className="col_koumoku_body" />
            </div>
            <div className="grid_item_detail">
              <div className="col_koumoku_header">
                <p className="nh">&nbsp;</p>
              </div>
              <div className="col_koumoku_body" />
            </div>
          </div>
        );
      } else {
        Nodes.push(
          <div className="fb flex_1">
            {row}
          </div>
        );
      }
    }

    return (
      <div className="grid_row_content_detail">
        {Nodes}
      </div>
    );

  }
}

MainGridRowDetailPachi.propTypes = {
  gridHeaderInfo: PropTypes.any.isRequired,
  gridData: PropTypes.any.isRequired,
};

export default MainGridRowDetailPachi;
